import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../module_roots/AuthContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUndo, faSearch, faFileInvoice, faCalendarAlt, faUser, faPhone,
    faMapMarkerAlt, faBox, faTag, faBarcode, faRupeeSign, faBalanceScale,
    faDollarSign, faCalculator, faExclamationTriangle, faTrash, faSave,
    faTimes, faSpinner, faCheckCircle, faExclamationCircle, faCreditCard,
    faMoneyBill, faWallet, faUniversity, faPercent, faReceipt, faChevronDown,
    faChevronUp, faBoxes, faHistory, faShoppingCart, faStore, faPlus,
    faMinus, faFilter, faPrint, faFilePdf, faQrcode, faTimesCircle,
    faIdCard, faLock, faEye, faEyeSlash, faCopy, faList, faFileAlt, faTrashAlt
} from '@fortawesome/free-solid-svg-icons';

const API_BASE = 'https://ourzestapp.online/oz_backend/mechanics_module';
const RETURN_API = 'https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_purchasereturn.php';
const ACCOUNTS_API = `${API_BASE}/mechanics_account.php`;

// ==================== TRANSLATOR ====================
const createPurchaseReturnTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_purchase_return_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found in Return Form");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_purchase_return_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Process Purchase Return': 'واپسی پر کارروائی کریں',
                'Return Items': 'آئٹمز واپس کریں',
                'Return Information': 'واپسی کی معلومات',
                'Return Number': 'واپسی نمبر',
                'Return Date': 'واپسی تاریخ',
                'Original Purchase Invoice': 'اصل انوائس',
                'Original Purchase Bill Number': 'اصل بل نمبر',
                'Original Date': 'اصل تاریخ',
                'Supplier Details': 'کسٹمر کی تفصیلات',
                'Supplier Name': 'کسٹمر کا نام',
                'Phone Number': 'فون نمبر',
                'Address': 'پتہ',
                'Search Invoice': 'انوائس تلاش کریں',
                'Enter Invoice': 'انوائس نمبر درج کریں',
                'Purchase invoice found': 'انوائس مل گئی',
                'Purchase invoice not found': 'انوائس نہیں ملی',
                'Items to Return': 'واپس کرنے کے لیے آئٹمز',
                'Product': 'پروڈکٹ',
                'Product Code': 'پروڈکٹ کوڈ',
                'Company': 'کمپنی',
                'Batch': 'بیچ',
                'Unit': 'یونٹ',
                'Price': 'قیمت',
                'Qty to Return': 'واپسی کی مقدار',
                'Available': 'دستیاب',
                'Total': 'کل',
                'Remove': 'ہٹائیں',
                'Return Calculations': 'واپسی کے حسابات',
                'Subtotal': 'ذیلی کل',
                'Tax': 'ٹیکس',
                'Discount': 'ڈسکاؤنٹ',
                'Grand Total': 'کل رقم',
                'Refund Amount': 'واپسی رقم',
                'Refund Method': 'واپسی کا طریقہ',
                'Cash': 'نقد',
                'Card': 'کارڈ',
                'UPI': 'یوپی آئی',
                'Bank Transfer': 'بینک ٹرانسفر',
                'Wallet': 'والٹ',
                'Return Reason': 'واپسی کی وجہ',
                'Notes': 'نوٹس',
                'Process Purchase Return': 'واپسی پر کارروائی کریں',
                'Clear': 'صاف کریں',
                'Processing...': 'کارروائی جاری ہے...',
                'Loading...': 'لوڈ ہو رہا ہے...',
                'Return processed successfully!': 'واپسی کامیابی سے مکمل ہو گئی!',
                'Failed to process return': 'واپسی پر کارروائی نہیں ہو سکی',
                'Network error occurred': 'نیٹ ورک کی خرابی',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'At least one item is required for return': 'کم از کم ایک آئٹم واپسی کے لیے ضروری ہے',
                'Quantity exceeds available stock': 'مقدار دستیاب اسٹاک سے زیادہ ہے',
                'Please enter a valid quantity': 'براہ کرم درست مقدار درج کریں',
                'Return reason is required': 'واپسی کی وجہ ضروری ہے',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Save Draft': 'ڈرافٹ محفوظ کریں',
                'Drafts': 'ڈرافٹس',
                'Saved Drafts': 'محفوظ کردہ ڈرافٹس',
                'No drafts saved': 'کوئی ڈرافٹ محفوظ نہیں',
                'Draft loaded': 'ڈرافٹ لوڈ ہو گیا',
                'Draft cleared': 'ڈرافٹ صاف ہو گیا',
                'Clear Form': 'فارم صاف کریں',
                'View Drafts': 'ڈرافٹس دیکھیں',
                'Go Back': 'واپس جائیں',
                'Search Invoice Number': 'انوائس نمبر تلاش کریں',
                'Search': 'تلاش کریں',
                'Purchase Return Receipt': 'واپسی رسید',
                'Return #': 'واپسی #',
                'Original Purchase Invoice #': 'اصل انوائس #',
                'Phone': 'فون',
                'Refund': 'واپسی',
                'Thank you for your business!': 'آپ کے کاروبار کا شکریہ!',
                'Powered by OurZest': 'OurZest کی طرف سے تقویت یافتہ'
            },
            'ar': {
                'Process Purchase Return': 'معالجة الإرجاع',
                'Return Items': 'إرجاع العناصر',
                'Return Information': 'معلومات الإرجاع',
                'Return Number': 'رقم الإرجاع',
                'Return Date': 'تاريخ الإرجاع',
                'Original Purchase Invoice': 'الفاتورة الأصلية',
                'Original Purchase Bill Number': 'رقم الفاتورة الأصلي',
                'Original Date': 'التاريخ الأصلي',
                'Supplier Details': 'تفاصيل العميل',
                'Supplier Name': 'اسم العميل',
                'Phone Number': 'رقم الهاتف',
                'Address': 'العنوان',
                'Search Invoice': 'البحث عن فاتورة',
                'Enter Invoice': 'أدخل رقم الفاتورة',
                'Purchase invoice found': 'تم العثور على الفاتورة',
                'Purchase invoice not found': 'لم يتم العثور على الفاتورة',
                'Items to Return': 'العناصر المراد إرجاعها',
                'Product': 'المنتج',
                'Product Code': 'رمز المنتج',
                'Company': 'الشركة',
                'Batch': 'الدفعة',
                'Unit': 'الوحدة',
                'Price': 'السعر',
                'Qty to Return': 'كمية الإرجاع',
                'Available': 'متوفر',
                'Total': 'المجموع',
                'Remove': 'إزالة',
                'Return Calculations': 'حسابات الإرجاع',
                'Subtotal': 'المجموع الفرعي',
                'Tax': 'الضريبة',
                'Discount': 'الخصم',
                'Grand Total': 'المجموع الكلي',
                'Refund Amount': 'مبلغ الاسترداد',
                'Refund Method': 'طريقة الاسترداد',
                'Cash': 'نقدي',
                'Card': 'بطاقة',
                'UPI': 'UPI',
                'Bank Transfer': 'تحويل بنكي',
                'Wallet': 'محفظة',
                'Return Reason': 'سبب الإرجاع',
                'Notes': 'ملاحظات',
                'Process Purchase Return': 'معالجة الإرجاع',
                'Clear': 'مسح',
                'Processing...': 'جاري المعالجة...',
                'Loading...': 'جاري التحميل...',
                'Return processed successfully!': 'تمت معالجة الإرجاع بنجاح!',
                'Failed to process return': 'فشل في معالجة الإرجاع',
                'Network error occurred': 'حدث خطأ في الشبكة',
                'No shop selected': 'لم يتم اختيار متجر',
                'At least one item is required for return': 'مطلوب عنصر واحد على الأقل للإرجاع',
                'Quantity exceeds available stock': 'الكمية تتجاوز المخزون المتوفر',
                'Please enter a valid quantity': 'الرجاء إدخال كمية صحيحة',
                'Return reason is required': 'سبب الإرجاع مطلوب',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Save Draft': 'حفظ المسودة',
                'Drafts': 'المسودات',
                'Saved Drafts': 'المسودات المحفوظة',
                'No drafts saved': 'لا توجد مسودات محفوظة',
                'Draft loaded': 'تم تحميل المسودة',
                'Draft cleared': 'تم مسح المسودة',
                'Clear Form': 'مسح النموذج',
                'View Drafts': 'عرض المسودات',
                'Go Back': 'رجوع',
                'Search Invoice Number': 'البحث عن رقم الفاتورة',
                'Search': 'بحث',
                'Purchase Return Receipt': 'إيصال الإرجاع',
                'Return #': 'إرجاع #',
                'Original Purchase Invoice #': 'الفاتورة الأصلية #',
                'Phone': 'هاتف',
                'Refund': 'استرداد',
                'Thank you for your business!': 'شكرا لتعاملكم معنا!',
                'Powered by OurZest': 'مدعوم من OurZest'
            },
            'es': {
                'Process Purchase Return': 'Procesar Devolución',
                'Return Items': 'Devolver Artículos',
                'Return Information': 'Información de Devolución',
                'Return Number': 'Número de Devolución',
                'Return Date': 'Fecha de Devolución',
                'Original Purchase Invoice': 'Factura Original',
                'Original Purchase Bill Number': 'Número de Factura Original',
                'Original Date': 'Fecha Original',
                'Supplier Details': 'Detalles del Cliente',
                'Supplier Name': 'Nombre del Cliente',
                'Phone Number': 'Número de Teléfono',
                'Address': 'Dirección',
                'Search Invoice': 'Buscar Factura',
                'Enter Invoice': 'Ingresar Número de Factura',
                'Purchase invoice found': 'Factura encontrada',
                'Purchase invoice not found': 'Factura no encontrada',
                'Items to Return': 'Artículos a Devolver',
                'Product': 'Producto',
                'Product Code': 'Código de Producto',
                'Company': 'Compañía',
                'Batch': 'Lote',
                'Unit': 'Unidad',
                'Price': 'Precio',
                'Qty to Return': 'Cantidad a Devolver',
                'Available': 'Disponible',
                'Total': 'Total',
                'Remove': 'Eliminar',
                'Return Calculations': 'Cálculos de Devolución',
                'Subtotal': 'Subtotal',
                'Tax': 'Impuesto',
                'Discount': 'Descuento',
                'Grand Total': 'Total General',
                'Refund Amount': 'Monto de Reembolso',
                'Refund Method': 'Método de Reembolso',
                'Cash': 'Efectivo',
                'Card': 'Tarjeta',
                'UPI': 'UPI',
                'Bank Transfer': 'Transferencia Bancaria',
                'Wallet': 'Billetera',
                'Return Reason': 'Motivo de Devolución',
                'Notes': 'Notas',
                'Process Purchase Return': 'Procesar Devolución',
                'Clear': 'Limpiar',
                'Processing...': 'Procesando...',
                'Loading...': 'Cargando...',
                'Return processed successfully!': '¡Devolución procesada exitosamente!',
                'Failed to process return': 'Error al procesar la devolución',
                'Network error occurred': 'Ocurrió un error de red',
                'No shop selected': 'No se seleccionó ninguna tienda',
                'At least one item is required for return': 'Se requiere al menos un artículo para devolver',
                'Quantity exceeds available stock': 'La cantidad excede el stock disponible',
                'Please enter a valid quantity': 'Por favor ingrese una cantidad válida',
                'Return reason is required': 'El motivo de devolución es requerido',
                'Success': 'Éxito',
                'Error': 'Error',
                'Warning': 'Advertencia',
                'Save Draft': 'Guardar Borrador',
                'Drafts': 'Borradores',
                'Saved Drafts': 'Borradores Guardados',
                'No drafts saved': 'No hay borradores guardados',
                'Draft loaded': 'Borrador cargado',
                'Draft cleared': 'Borrador limpiado',
                'Clear Form': 'Limpiar Formulario',
                'View Drafts': 'Ver Borradores',
                'Go Back': 'Volver',
                'Search Invoice Number': 'Buscar Número de Factura',
                'Search': 'Buscar',
                'Purchase Return Receipt': 'Recibo de Devolución',
                'Return #': 'Devolución #',
                'Original Purchase Invoice #': 'Factura Original #',
                'Phone': 'Teléfono',
                'Refund': 'Reembolso',
                'Thank you for your business!': '¡Gracias por su preferencia!',
                'Powered by OurZest': 'Desarrollado por OurZest'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) {
            console.log("LibreTranslate failed, trying MyMemory");
        }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) {
            console.log("MyMemory translation failed");
        }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;

        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }

        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();

        return translated;
    };

    const defaultTexts = {
        processReturn: 'Process Purchase Return',
        returnItems: 'Return Items',
        returnInformation: 'Return Information',
        returnNumber: 'Return Number',
        returnDate: 'Return Date',
        originalInvoice: 'Original Purchase Invoice',
        originalBillNumber: 'Original Purchase Bill Number',
        originalDate: 'Original Date',
        supplierDetails: 'Supplier Details',
        supplierName: 'Supplier Name',
        supplierPhone: 'Phone Number',
        supplierAddress: 'Address',
        searchInvoice: 'Search Invoice',
        searchPlaceholder: 'Enter Purchase Bill Number, Supplier Name or Phone',
        invoiceFound: 'Purchase invoice found',
        invoiceNotFound: 'Purchase invoice not found',
        itemsToReturn: 'Items to Return',
        productName: 'Product',
        productCode: 'Product Code',
        company: 'Company',
        batchNumber: 'Batch',
        unit: 'Unit',
        price: 'Price',
        quantityToReturn: 'Qty to Return',
        available: 'Purchased',
        total: 'Total',
        remove: 'Remove',
        returnCalculations: 'Return Calculations',
        subtotal: 'Subtotal',
        tax: 'Tax',
        discount: 'Discount',
        grandTotal: 'Grand Total',
        refundAmount: 'Supplier Refund Received',
        refundMethod: 'Refund Method',
        cash: 'Cash',
        card: 'Card',
        upi: 'UPI',
        bankTransfer: 'Bank Transfer',
        wallet: 'Wallet',
        returnReason: 'Return Reason',
        notes: 'Notes',
        processReturnBtn: 'Process Purchase Return',
        clear: 'Clear',
        saving: 'Processing...',
        loading: 'Loading...',
        returnProcessed: 'Return processed successfully!',
        failedProcess: 'Failed to process return',
        networkError: 'Network error occurred',
        noShopSelected: 'No shop selected',
        itemsRequired: 'At least one item is required for return',
        quantityExceedsAvailable: 'Quantity exceeds available stock',
        invalidQuantity: 'Please enter a valid quantity',
        returnReasonRequired: 'Return reason is required',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        saveDraft: 'Save Draft',
        drafts: 'Drafts',
        savedDrafts: 'Saved Drafts',
        noDraftsSaved: 'No drafts saved',
        draftLoaded: 'Draft loaded',
        draftCleared: 'Draft cleared',
        clearForm: 'Clear Form',
        viewDrafts: 'View Drafts',
        goBack: 'Go Back',
        search: 'Search',
        returnReceipt: 'Purchase Return Receipt',
        returnHash: 'Return #',
        originalInvoiceHash: 'Original Purchase Invoice #',
        phone: 'Phone',
        refund: 'Refund',
        thankYou: 'Thank you for your business!',
        poweredBy: 'Powered by OurZest'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const purchaseReturnTranslator = createPurchaseReturnTranslator();

// ==================== TOAST NOTIFICATION ====================
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations?.success || 'Success';
            case 'error': return translations?.error || 'Error';
            case 'warning': return translations?.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// ==================== RETURN ITEMS TABLE COMPONENT ====================
const PurchaseReturnItemsTable = ({
    items,
    onQuantityChange,
    onRemove,
    errors,
    disabled,
    translations,
    isRTL
}) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const calculateTotal = (price, quantity) => {
        const p = parseFloat(price) || 0;
        const q = parseFloat(quantity) || 0;
        return String(Math.round(p * q));
    };

    if (isMobile) {
        return (
            <div className="ozui-items-mobile-container">
                <div className="ozui-items-header-mobile">
                    <h4><FontAwesomeIcon icon={faBoxes} />{translations?.itemsToReturn || 'Items to Return'}</h4>
                </div>
                <div className="ozui-items-cards-container">
                    {items.map((item, index) => (
                        <div key={index} className="ozui-item-card-mobile">
                            <div className="ozui-item-card-header">
                                <span className="ozui-item-number">{item.product_name}</span>
                                <button type="button" className="ozui-item-remove-btn-mobile" onClick={() => onRemove(index)} disabled={disabled}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </div>
                            <div className="ozui-item-card-content">
                                {item.product_code && (
                                    <div className="ozui-mobile-field">
                                        <label>{translations?.productCode || 'Product Code'}</label>
                                        <input type="text" value={item.product_code} readOnly className="ozui-readonly-input" />
                                    </div>
                                )}
                                {item.company_name && (
                                    <div className="ozui-mobile-field">
                                        <label>{translations?.company || 'Company'}</label>
                                        <input type="text" value={item.company_name} readOnly className="ozui-readonly-input" />
                                    </div>
                                )}
                                <div className="ozui-mobile-field">
                                    <label>{translations?.batchNumber || 'Batch'}</label>
                                    <input type="text" value={item.batch_no} readOnly className="ozui-readonly-input" />
                                </div>
                                <div className="ozui-mobile-field">
                                    <label>{translations?.unit || 'Unit'}</label>
                                    <input type="text" value={item.unit} readOnly className="ozui-readonly-input" />
                                </div>
                                <div className="ozui-mobile-row">
                                    <div className={`ozui-mobile-field half ${errors[`quantity_${index}`] ? 'ozui-has-error' : ''}`}>
                                        <label>{translations?.quantityToReturn || 'Qty to Return'} *</label>
                                        {/* ✅ FIXED: Fully flexible quantity - no forced values, supports decimals */}
                                        <input 
                                            type="text" 
                                            value={item.return_quantity || ''} 
                                            onChange={(e) => onQuantityChange(index, e.target.value)} 
                                            step="any" 
                                            min="0" 
                                            placeholder="0" 
                                            disabled={disabled} 
                                            dir="ltr"
                                            inputMode="decimal"
                                        />
                                        <small className="ozui-stock-hint">{translations?.available || 'Purchased'}: {item.available_for_return} </small>
                                    </div>
                                    <div className="ozui-mobile-field half">
                                        <label>{translations?.price || 'Price'}</label>
                                        <input type="text" value={item.price} readOnly className="ozui-readonly-input" />
                                    </div>
                                </div>
                                <div className="ozui-mobile-row">
                                    <div className="ozui-mobile-field half">
                                        <label>{translations?.total || 'Total'}</label>
                                        <input type="text" value={calculateTotal(item.price, item.return_quantity)} readOnly disabled className="ozui-readonly-input ozui-total-display" />
                                    </div>
                                </div>
                                {errors[`quantity_${index}`] && (
                                    <div className="ozui-error-text"><FontAwesomeIcon icon={faExclamationTriangle} />{errors[`quantity_${index}`]}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="ozui-items-table-container">
            <div className="ozui-table-header-actions">
                <h4><FontAwesomeIcon icon={faBoxes} />{translations?.itemsToReturn || 'Items to Return'}</h4>
            </div>
            <div className="ozui-table-wrapper">
                <table className="ozui-items-table">
                    <thead>
                        <tr>
                            <th>{translations?.productName || 'Product'}</th>
                            <th>{translations?.productCode || 'Product Code'}</th>
                            <th>{translations?.company || 'Company'}</th>
                            <th>{translations?.batchNumber || 'Batch'}</th>
                            <th>{translations?.unit || 'Unit'}</th>
                            <th>{translations?.price || 'Price'}</th>
                            <th>{translations?.quantityToReturn || 'Qty to Return'}</th>
                            <th>{translations?.total || 'Total'}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index} className={errors[`quantity_${index}`] ? 'ozui-error-row' : ''}>
                                <td>
                                    <div className="ozui-table-field">
                                        <input type="text" value={item.product_name} readOnly className="ozui-readonly-input" />
                                    </div>
                                </td>
                                <td>
                                    <div className="ozui-table-field">
                                        <input type="text" value={item.product_code || '-'} readOnly className="ozui-readonly-input" />
                                    </div>
                                </td>
                                <td>
                                    <div className="ozui-table-field">
                                        <input type="text" value={item.company_name || '-'} readOnly className="ozui-readonly-input" />
                                    </div>
                                </td>
                                <td>
                                    <div className="ozui-table-field">
                                        <input type="text" value={item.batch_no || '-'} readOnly className="ozui-readonly-input" />
                                    </div>
                                </td>
                                <td>
                                    <div className="ozui-table-field">
                                        <input type="text" value={item.unit} readOnly className="ozui-readonly-input" />
                                    </div>
                                </td>
                                <td>
                                    <div className="ozui-table-field">
                                        <input type="number" value={item.price} readOnly className="ozui-readonly-input" />
                                    </div>
                                </td>
                                <td>
                                    <div className="ozui-table-field">
                                        <input type="number" value={item.return_quantity || ''} onChange={(e) => onQuantityChange(index, e.target.value)} step="1" min="1" max={item.available_for_return} placeholder="0" disabled={disabled} dir="ltr" className={errors[`quantity_${index}`] ? 'ozui-error' : ''} />
                                        <small className="ozui-stock-hint">{translations?.available || 'Available'}: {item.available_for_return}</small>
                                        {errors[`quantity_${index}`] && <div className="ozui-table-error"><FontAwesomeIcon icon={faExclamationTriangle} />{errors[`quantity_${index}`]}</div>}
                                    </div>
                                </td>
                                <td>
                                    <div className="ozui-table-field">
                                        <input type="text" value={calculateTotal(item.price, item.return_quantity)} readOnly disabled className="ozui-readonly-input ozui-total-display" />
                                    </div>
                                </td>
                                <td>
                                    <button type="button" className="ozui-table-remove-btn" onClick={() => onRemove(index)} disabled={disabled} title={translations?.remove || 'Remove'}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// ==================== MAIN RETURN COMPONENT ====================
const CosmeticsPurchaseReturn = () => {
    const { user, currentShop } = useAuth();

    const initialFormData = {
        return_number: '',
        return_number_int: 0,
        purchase_id: null,
        date: new Date().toISOString().split('T')[0],
        supplier_id: null,
        supplier_name: '',
        supplier_phone: '',
        subtotal: '0',
        tax: '0',
        discount: '0',
        grand_total: '0',
        refund_amount: '0',
        payment_method: 'cash',
        payment_account_id: '',
        return_reason: '',
        notes: '',
        items: []
    };

    const [formData, setFormData] = useState(initialFormData);
    const [searchTerm, setSearchTerm] = useState('');
    const [searching, setSearching] = useState(false);
    const [invoiceFound, setInvoiceFound] = useState(false);
    const [originalPurchase, setOriginalPurchase] = useState(null);
    const [businessInfo, setBusinessInfo] = useState({
        businessname: '',
        bussinesslogo: '',
        bussinesslogo_url: '',
        businessaddress: '',
        fullname: '',
        email: '',
        phonenumber: '',
        gst_number: ''
    });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const [currentLanguage, setCurrentLanguage] = useState(() => localStorage.getItem('ourzest_language') || 'en');
    const [translations, setTranslations] = useState({});
    const [darkMode, setDarkMode] = useState(() => localStorage.getItem('ourzest_darkMode') === 'true');
    const [currentThemeColor, setCurrentThemeColor] = useState(() => localStorage.getItem('ourzest_theme') || '#6366f1');
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [currentPurchaseReturn, setCurrentPurchaseReturn] = useState(null);
    const [hasDraft, setHasDraft] = useState(false);
    const [paymentAccounts, setPaymentAccounts] = useState([]);
    
    // Draft State
    const [showDraftsList, setShowDraftsList] = useState(false);
    const [savedDrafts, setSavedDrafts] = useState([]);
    
    // Auto-focus ref for Invoice Search field
    const invoiceSearchRef = useRef(null);
    
    // Refs
    const toastTimerRef = useRef(null);
    const isSubmittingRef = useRef(false);
    const isClearingRef = useRef(false);
    const isInitialLoadRef = useRef(true);
    const draftsDropdownRef = useRef(null);
    const submitButtonRef = useRef(null);
    const refundManuallyEditedRef = useRef(false);

    // Tab key handler to close all dropdowns
    useEffect(() => {
        const handleTabKey = (e) => {
            if (e.key === 'Tab') {
                setShowDraftsList(false);
            }
        };
        document.addEventListener('keydown', handleTabKey);
        return () => document.removeEventListener('keydown', handleTabKey);
    }, []);

    // Auto-focus on Invoice Search field when component mounts
    useEffect(() => {
        setTimeout(() => {
            if (invoiceSearchRef.current) {
                invoiceSearchRef.current.focus();
            }
        }, 100);
    }, []);

    // ============================================
    // Draft Management Functions
    // ============================================
    const getDraftStorageKey = () => {
        const userId = user?.user_id || user?.username || 'anonymous';
        const shopId = currentShop?.shop_id || 'no_shop';
        return `purchase_return_draft_${userId}_${shopId}`;
    };

    const saveDraft = () => {
        const hasData = formData.purchase_id || (formData.items && formData.items.some(item => parseFloat(item.return_quantity) > 0)) || formData.return_reason?.trim();
        if (!hasData) {
            showToast('warning', 'Cannot save empty draft');
            return;
        }
        
        const draftId = Date.now();
        const draft = {
            id: draftId,
            ...formData,
            searchTerm,
            originalPurchase,
            invoiceFound,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };
        
        const existingDrafts = JSON.parse(localStorage.getItem(getDraftStorageKey()) || '[]');
        existingDrafts.unshift(draft);
        const limitedDrafts = existingDrafts.slice(0, 20);
        localStorage.setItem(getDraftStorageKey(), JSON.stringify(limitedDrafts));
        
        showToast('success', 'Draft saved successfully!');
        loadDrafts();
    };

    const loadDrafts = () => {
        const drafts = JSON.parse(localStorage.getItem(getDraftStorageKey()) || '[]');
        const filteredDrafts = currentShop ? drafts.filter(d => d.shop_id === currentShop?.shop_id) : drafts;
        setSavedDrafts(filteredDrafts);
    };

    const loadDraft = (draft) => {
        setFormData({
            ...initialFormData,
            ...draft,
            date: draft.date || new Date().toISOString().split('T')[0],
            items: draft.items || []
        });
        if (draft.searchTerm) setSearchTerm(draft.searchTerm);
        if (draft.originalPurchase) setOriginalPurchase(draft.originalPurchase);
        if (draft.invoiceFound) setInvoiceFound(draft.invoiceFound);
        setShowDraftsList(false);
        showToast('success', translations.draftLoaded || 'Draft loaded successfully!');
        
        setTimeout(() => {
            if (invoiceSearchRef.current) {
                invoiceSearchRef.current.focus();
            }
        }, 100);
    };

    const deleteDraft = (draftId) => {
        const drafts = JSON.parse(localStorage.getItem(getDraftStorageKey()) || '[]');
        const filteredDrafts = drafts.filter(d => d.id !== draftId);
        localStorage.setItem(getDraftStorageKey(), JSON.stringify(filteredDrafts));
        loadDrafts();
        showToast('success', 'Draft deleted successfully!');
    };

    const clearDraft = () => {
        if (isSubmittingRef.current) { showToast('warning', 'Please wait for current operation to complete'); return; }
        isClearingRef.current = true;
        clearDraftFromStorage();
        setFormData(initialFormData);
        setSearchTerm('');
        setInvoiceFound(false);
        setOriginalPurchase(null);
        setErrors({});
        setHasDraft(false);
        refundManuallyEditedRef.current = false;
        getNextReturnNumber();
        showToast('success', translations.draftCleared || 'Form cleared');
        
        setTimeout(() => {
            if (invoiceSearchRef.current) {
                invoiceSearchRef.current.focus();
            }
        }, 100);
        
        setTimeout(() => { isClearingRef.current = false; }, 500);
    };

    const clearDraftFromStorage = () => {
        try { 
            localStorage.removeItem(getDraftStorageKey()); 
            setHasDraft(false); 
        } catch (error) {}
    };
    
    const checkDraftExists = () => {
        try { 
            setHasDraft(!!localStorage.getItem(getDraftStorageKey())); 
        } catch (error) {}
    };

    // ============================================
    // Theme Color Auto-Sync
    // ============================================
    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
            color = '#6366f1';
        }
        document.documentElement.style.setProperty('--ozui-primary', color);
        document.documentElement.style.setProperty('--ozui-primary-dark', color);
        document.documentElement.style.setProperty('--ozui-primary-light', color);
        
        let r, g, b;
        if (color.startsWith('#')) {
            r = parseInt(color.slice(1, 3), 16);
            g = parseInt(color.slice(3, 5), 16);
            b = parseInt(color.slice(5, 7), 16);
        } else {
            r = 99; g = 102; b = 241;
        }
        
        let style = document.getElementById('dynamic-orb-styles-purchase-return');
        if (!style) {
            style = document.createElement('style');
            style.id = 'dynamic-orb-styles-purchase-return';
            document.head.appendChild(style);
        }
        
        style.textContent = `
            .ozui-header-bg-animation .gradient-orb.orb-1 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.4) 0%, rgba(${r}, ${g}, ${b}, 0.1) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-2 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.35) 0%, rgba(${r}, ${g}, ${b}, 0.08) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-3 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.05) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-4 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.25) 0%, rgba(${r}, ${g}, ${b}, 0.03) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-5 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.2) 0%, rgba(${r}, ${g}, ${b}, 0.02) 100%);
            }
        `;
        
        setCurrentThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                applyTheme(e.newValue || '#6366f1');
            }
        };
        
        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
        };
    }, [applyTheme]);

    // ============================================
    // Dark Mode Auto-Sync
    // ============================================
    useEffect(() => {
        const syncDarkMode = () => {
            const isDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDarkMode);
            
            const container = document.querySelector('.ozui-container');
            if (container) {
                if (isDarkMode) {
                    container.classList.add('ozui-dark');
                } else {
                    container.classList.remove('ozui-dark');
                }
            }
            
            if (isDarkMode) {
                document.body.classList.add('ozui-dark');
                document.documentElement.classList.add('ozui-dark');
            } else {
                document.body.classList.remove('ozui-dark');
                document.documentElement.classList.remove('ozui-dark');
            }
        };
        
        syncDarkMode();
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };
        
        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
            } else {
                syncDarkMode();
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
        };
    }, []);

    // ============================================
    // Language Auto-Sync
    // ============================================
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await purchaseReturnTranslator.getTranslations(lang);
            setTranslations(trans);
        };
        
        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };
        
        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };
        
        loadTranslations(currentLanguage);
        
        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);
        
        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);
        
        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);

    // ============================================
    // RTL Direction Sync
    // ============================================
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozui-container');
        
        if (container) {
            if (isRTL) {
                container.classList.add('ozui-rtl');
                container.classList.remove('ozui-ltr');
            } else {
                container.classList.add('ozui-ltr');
                container.classList.remove('ozui-rtl');
            }
        }
        
        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // Load drafts on shop change
    useEffect(() => {
        loadDrafts();
    }, [currentShop]);

    // Position drafts dropdown
    useEffect(() => {
        if (showDraftsList && draftsDropdownRef.current) {
            const button = draftsDropdownRef.current.querySelector('.drafts-btn');
            const dropdown = draftsDropdownRef.current.querySelector('.ozui-drafts-dropdown');
            
            if (button && dropdown) {
                const rect = button.getBoundingClientRect();
                dropdown.style.position = 'fixed';
                dropdown.style.top = `${rect.bottom + 8}px`;
                dropdown.style.right = `${window.innerWidth - rect.right}px`;
            }
        }
    }, [showDraftsList]);

    // Click outside for drafts dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (draftsDropdownRef.current && !draftsDropdownRef.current.contains(event.target)) {
                setShowDraftsList(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        setToast({ show: true, type, message });
        toastTimerRef.current = setTimeout(() => {
            setToast({ show: false, type: '', message: '' });
        }, 3000);
    }, []);

    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        };
    }, []);

    useEffect(() => { checkDraftExists(); }, [currentShop?.shop_id]);

    useEffect(() => {
        if (currentShop?.shop_id && isInitialLoadRef.current) {
            isInitialLoadRef.current = false;
            const savedDraft = localStorage.getItem(getDraftStorageKey());
            if (savedDraft) {
                try {
                    const draftData = JSON.parse(savedDraft);
                    setFormData(prev => ({ ...prev, ...draftData.formData }));
                    if (draftData.searchTerm) setSearchTerm(draftData.searchTerm);
                    if (draftData.originalPurchase) setOriginalPurchase(draftData.originalPurchase);
                    if (draftData.invoiceFound) setInvoiceFound(draftData.invoiceFound);
                    setHasDraft(true);
                    showToast('info', translations?.draftLoaded || 'Loaded saved draft');
                } catch (error) {}
            }
        }
    }, [currentShop?.shop_id, translations]);

    const loadBusinessInfo = useCallback(async () => {
        if (!user?.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php?action=get_business_info&username=' + encodeURIComponent(user.username), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                credentials: 'include'
            });
            const data = await response.json();
            if (data.status === 'success') {
                setBusinessInfo({
                    businessname: data.businessname || '',
                    bussinesslogo: data.bussinesslogo || '',
                    bussinesslogo_url: data.bussinesslogo_url || '',
                    businessaddress: data.businessaddress || '',
                    fullname: data.fullname || '',
                    email: data.email || '',
                    phonenumber: data.phonenumber || '',
                    gst_number: data.gst_number || ''
                });
            } else {
                setBusinessInfo({
                    businessname: user.business_name || user.fullname || '',
                    bussinesslogo: user.bussinesslogo || '',
                    bussinesslogo_url: user.bussinesslogo_url || '',
                    businessaddress: user.business_address || '',
                    fullname: user.fullname || '',
                    email: user.email || '',
                    phonenumber: user.phonenumber || '',
                    gst_number: user.gst_number || ''
                });
            }
        } catch (error) {
            console.error('Error loading business info:', error);
            setBusinessInfo({
                businessname: user.business_name || user.fullname || '',
                bussinesslogo: user.bussinesslogo || '',
                bussinesslogo_url: user.bussinesslogo_url || '',
                businessaddress: user.business_address || '',
                fullname: user.fullname || '',
                email: user.email || '',
                phonenumber: user.phonenumber || '',
                gst_number: user.gst_number || ''
            });
        }
    }, [user]);

    useEffect(() => {
        if (currentShop?.shop_id) {
            getNextReturnNumber();
        }
        loadBusinessInfo();
    }, [currentShop, loadBusinessInfo]);

    useEffect(() => {
        if (!currentShop?.shop_id) {
            setPaymentAccounts([]);
            return;
        }
        let cancelled = false;
        fetch(ACCOUNTS_API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
                action: 'list_accounts',
                shop_id: currentShop.shop_id,
                username: user?.username || 'system',
                active_only: true
            })
        })
            .then(response => response.json())
            .then(result => {
                if (!cancelled) setPaymentAccounts(result.status === 'success' && Array.isArray(result.data) ? result.data : []);
            })
            .catch(() => { if (!cancelled) setPaymentAccounts([]); });
        return () => { cancelled = true; };
    }, [currentShop?.shop_id, user?.username]);

    const getNextReturnNumber = async () => {
        if (!currentShop?.shop_id) return;
        try {
            const response = await fetch(RETURN_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_next_return_number', shop_id: currentShop.shop_id })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setFormData(prev => ({ ...prev, return_number: data.data.return_number, return_number_int: data.data.return_number_int }));
            }
        } catch (error) {
            console.error('Error getting next return number:', error);
        }
    };

    const searchInvoice = async () => {
        if (!searchTerm.trim()) {
            showToast('error', translations?.searchPlaceholder || 'Please enter an invoice number');
            return;
        }
        if (!currentShop?.shop_id) {
            showToast('error', translations?.noShopSelected || 'No shop selected');
            return;
        }
        setSearching(true);
        refundManuallyEditedRef.current = false;
        setInvoiceFound(false);
        setOriginalPurchase(null);
        setFormData(prev => ({
            ...prev, purchase_id: null, supplier_id: null, supplier_name: '', supplier_phone: '',
            subtotal: '0', tax: '0', discount: '0', grand_total: '0', refund_amount: '0', items: []
        }));
        try {
            const response = await fetch(RETURN_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'search_invoice', search_term: searchTerm, shop_id: currentShop.shop_id })
            });
            const data = await response.json();
            if (data.status === 'success' && data.data) {
                setInvoiceFound(true);
                setOriginalPurchase(data.data);
                const returnItems = data.data.items.map(item => ({
                    ...item,
                    return_quantity: '',
                    purchase_item_id: item.id,
                    product_code: item.product_code || '',
                    company_name: item.company_name || item.company || '',
                    available_for_return: parseFloat(item.quantity) || 0
                }));
                setFormData(prev => ({
                    ...prev,
                    purchase_id: data.data.id,
                    supplier_id: data.data.supplierid ?? data.data.supplier_id,
                    supplier_name: data.data.supplier_name || '',
                    supplier_phone: data.data.supplier_phone || data.data.phone || '',
                    subtotal: '0',
                    grand_total: '0',
                    refund_amount: '0',
                    items: returnItems
                }));
                showToast('success', `${translations?.invoiceFound || 'Purchase invoice found'}: #${data.data.bill_no}`);
            } else {
                showToast('error', data.message || translations?.invoiceNotFound || 'Purchase invoice not found');
            }
        } catch (error) {
            console.error('Error searching invoice:', error);
            showToast('error', translations?.networkError || 'Network error occurred');
        } finally {
            setSearching(false);
        }
    };

    const handleQuantityChange = (index, value) => {
        const updatedItems = [...formData.items];
        const item = updatedItems[index];
        const qty = value === '' ? '' : parseFloat(value);
        if (qty !== '' && (isNaN(qty) || qty < 0)) return;
        if (qty !== '' && qty > item.available_for_return) {
            setErrors(prev => ({ ...prev, [`quantity_${index}`]: `${translations?.quantityExceedsAvailable || 'Cannot return more than'} ${item.available_for_return}` }));
            return;
        }
        if (errors[`quantity_${index}`]) {
            setErrors(prev => { const newErrors = { ...prev }; delete newErrors[`quantity_${index}`]; return newErrors; });
        }
        item.return_quantity = qty === '' ? '' : qty;
        setFormData(prev => ({ ...prev, items: updatedItems }));
    };

    const removeItem = (index) => {
        const updatedItems = [...formData.items];
        updatedItems.splice(index, 1);
        setFormData(prev => ({ ...prev, items: updatedItems }));
        setErrors(prev => { const newErrors = { ...prev }; delete newErrors[`quantity_${index}`]; return newErrors; });
    };

    const calculateTotals = () => {
        let subtotal = 0;
        let hasAnyReturn = false;
        formData.items.forEach(item => {
            if (item.return_quantity && parseFloat(item.return_quantity) > 0) {
                hasAnyReturn = true;
                const price = parseFloat(item.price) || 0;
                const quantity = parseFloat(item.return_quantity) || 0;
                subtotal += price * quantity;
            }
        });
        const tax = parseFloat(formData.tax) || 0;
        const discount = parseFloat(formData.discount) || 0;
        const grandTotal = subtotal + tax - discount;
        const currentRefund = parseFloat(formData.refund_amount) || 0;
        const refundAmount = refundManuallyEditedRef.current
            ? Math.min(Math.max(0, currentRefund), Math.max(0, grandTotal))
            : grandTotal;
        setFormData(prev => ({ ...prev, subtotal: String(Math.round(subtotal)), grand_total: String(Math.round(grandTotal)), refund_amount: String(Math.round(refundAmount)) }));
        return hasAnyReturn;
    };

    useEffect(() => {
        calculateTotals();
    }, [formData.items, formData.tax, formData.discount]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.purchase_id) newErrors.invoice = translations?.invoiceNotFound || 'Please search and select an invoice first';
        if (!formData.items || formData.items.length === 0) {
            newErrors.items = translations?.itemsRequired || 'At least one item is required for return';
        } else {
            let hasValidReturn = false;
            formData.items.forEach((item, index) => {
                const qty = parseFloat(item.return_quantity) || 0;
                if (qty > 0) {
                    hasValidReturn = true;
                    if (qty > item.available_for_return) newErrors[`quantity_${index}`] = `${translations?.quantityExceedsAvailable || 'Cannot return more than'} ${item.available_for_return}`;
                    if (qty <= 0) newErrors[`quantity_${index}`] = translations?.invalidQuantity || 'Please enter a valid quantity';
                }
            });
            if (!hasValidReturn) newErrors.items = translations?.itemsRequired || 'Please enter at least one item to return';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

// ============================================
// PRINT RECEIPT FUNCTION - OPENS IN _BLANK ONLY
// ============================================
const handlePrintReceipt = (returnData) => {
    if (!returnData) return;
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        showToast('error', 'Please allow popups for printing');
        return;
    }

    const businessName = businessInfo?.businessname || user?.business_name || user?.fullname || currentShop?.shop_name || 'OurZest Store';
    const businessLogo = businessInfo?.bussinesslogo_url || businessInfo?.bussinesslogo || '';
    const businessAddress = businessInfo?.businessaddress || user?.business_address || '';
    const businessPhone = businessInfo?.phonenumber || user?.phonenumber || '';
    const businessEmail = businessInfo?.email || user?.email || '';
    const supplierName = returnData.supplier_name || 'Walk-in Supplier';
    const supplierPhone = returnData.supplier_phone || '';
    const returnNumber = returnData.return_number || returnData.id || '';
    const allowedSizes = { A4: 'A4', A5: 'A5', LETTER: 'Letter', LEGAL: 'Legal' };
    const savedSize = String(localStorage.getItem('receipt_paper_size') || 'A4').toUpperCase();
    const printPageSize = allowedSizes[savedSize] || 'A4';
    const money = value => `Rs. ${Math.round(Number.parseFloat(value) || 0)}`;
    const escapePrintHtml = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[char]));
    const businessWords = String(businessName).trim().split(/\s+/).filter(Boolean);
    const secondaryWords = businessWords.slice(2);
    const printBusinessName = { primary: businessWords.slice(0, 2).join(' '), secondary: secondaryWords.join(' '), secondaryUnits: secondaryWords.length === 1 ? Array.from(secondaryWords[0]) : secondaryWords };
    const receiptDate = (() => {
        const date = returnData.date ? new Date(returnData.date) : new Date();
        const safeDate = Number.isNaN(date.getTime()) ? new Date() : date;
        return safeDate.toLocaleString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    })();

    printWindow.document.write(`<!DOCTYPE html>
<html><head><meta charset="UTF-8"><title>Purchase Return Receipt ${escapePrintHtml(returnNumber)}</title>
<style>
@page { size: ${printPageSize} portrait; margin: 12mm; }
* { box-sizing: border-box; }
:root { --ink: #000; --muted: #444; --line: #b8b8b8; }
body { margin: 0; color: var(--ink); background: #fff; font: 10pt/1.45 'Segoe UI', Arial, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
.receipt { width: 100%; margin: 0 auto; }
.header { margin-bottom: 0; text-align: left; }
.brand { display: flex; align-items: center; justify-content: flex-start; gap: 18px; min-height: 140px; margin-left: -18px; padding: 14px 4px 22px; }
.logo { display: block; flex: 0 0 auto; width: 158px; max-width: 158px; max-height: 112px; object-fit: contain; filter: grayscale(100%) contrast(115%); }
.business-copy { min-width: 0; text-align: left; }
.business-name-lockup { display: inline-flex; flex-direction: column; width: max-content; max-width: 100%; }
.business-name-primary { font-size: 28pt; font-weight: 850; letter-spacing: .25px; line-height: 1.02; overflow-wrap: anywhere; }
.business-name-secondary { display: flex; justify-content: space-between; width: 100%; margin-top: 4px; font-size: 17pt; font-weight: 650; line-height: 1.1; overflow-wrap: anywhere; }
.business-detail { margin-top: 5px; color: var(--muted); font-size: 10.5pt; line-height: 1.3; overflow-wrap: anywhere; }
.contact-line { display: flex; justify-content: flex-start; flex-wrap: wrap; gap: 3px 18px; }
.receipt-heading { padding: 8px 18px 9px; color: #000; background: #f7f7f7; border: 1px solid #888; border-radius: 3px 3px 0 0; }
.receipt-title { font-size: 15pt; font-weight: 800; letter-spacing: 2.5px; text-transform: uppercase; }
.meta { display: grid; grid-template-columns: 1.25fr .9fr 1fr; gap: 0; margin: 0 0 10px; background: #fff; border: 1px solid #888; border-top: 0; border-radius: 0 0 3px 3px; overflow: hidden; }
.meta > span { min-height: 46px; padding: 7px 10px; border-right: 1px solid #aaa; display: flex; flex-direction: column; justify-content: center; }
.meta > span:last-child { border-right: 0; }
.meta strong, .return-info strong { color: var(--muted); font-size: 7.5pt; letter-spacing: .6px; text-transform: uppercase; }
.meta-value { color: var(--ink); font-weight: 650; overflow-wrap: anywhere; }
.meta-subvalue { margin-top: 1px; color: var(--muted); font-size: 8pt; overflow-wrap: anywhere; }
.return-info { display: grid; grid-template-columns: .8fr 1.2fr; gap: 0; margin-bottom: 14px; border: 1px solid var(--line); border-radius: 3px; overflow: hidden; }
.return-info > div { min-height: 40px; padding: 6px 10px; border-right: 1px solid var(--line); display: flex; flex-direction: column; justify-content: center; }
.return-info > div:last-child { border-right: 0; }
table { width: 100%; margin: 0 0 16px; border-collapse: separate; border-spacing: 0; border: 1px solid var(--line); border-radius: 3px; overflow: hidden; }
thead { display: table-header-group; }
th { color: #000; background: #f7f7f7; font-size: 7.5pt; font-weight: 700; letter-spacing: .4px; line-height: 1.15; text-transform: uppercase; }
th, td { padding: 5px 6px; border: 0; border-right: 1px solid var(--line); border-bottom: 1px solid var(--line); line-height: 1.2; vertical-align: middle; }
th:last-child, td:last-child { border-right: 0; }
tbody tr:last-child td { border-bottom: 0; }
tbody tr:nth-child(even) { background: #fafafa; }
th:not(:nth-child(2)), td:not(:nth-child(2)) { text-align: center; }
th:nth-child(2), td:nth-child(2) { text-align: left; }
tr { break-inside: avoid; page-break-inside: avoid; }
.product { font-weight: 650; overflow-wrap: anywhere; }
.item-meta { display: block; margin-top: 1px; color: var(--muted); font-size: 7pt; }
.payment-section { display: flex; justify-content: flex-end; break-inside: avoid; page-break-inside: avoid; }
.payment-box { width: 310px; background: #fff; border: 1px solid var(--line); border-radius: 3px; overflow: hidden; }
.payment-row { display: flex; justify-content: space-between; gap: 20px; padding: 5px 12px; }
.payment-row:first-child { padding-top: 9px; }
.payment-row:last-child { padding-bottom: 9px; }
.payment-row.total, .payment-row.refund { margin: 4px 0; padding: 8px 12px; color: #000; background: #f7f7f7; border-top: 1px solid #999; border-bottom: 1px solid #999; font-size: 12pt; font-weight: 800; }
.payment-row.refund { margin-bottom: 0; border-bottom: 0; }
.footer { margin-top: 22px; padding-top: 12px; border-top: 1px solid var(--line); color: var(--muted); font-size: 8pt; text-align: center; break-inside: avoid; }
.thanks { margin-bottom: 2px; color: var(--ink); font-size: 11pt; font-weight: 700; }
@media print and (max-width: 160mm) {
  body { font-size: 8.5pt; } .business-name-primary { font-size: 22pt; } .business-name-secondary { font-size: 13.5pt; } .receipt-title { font-size: 12pt; }
  .brand { min-height: 106px; margin-left: -12px; gap: 14px; padding: 8px 2px 14px; } .logo { width: 112px; max-width: 112px; max-height: 80px; } th, td { padding: 4px; font-size: 7pt; }
  .payment-box { width: 245px; } .meta > span { min-height: 40px; padding: 5px 6px; }
  .meta { grid-template-columns: 1.15fr .9fr 1fr; } .meta strong, .return-info strong { font-size: 6.5pt; } .meta-value { font-size: 8pt; } .meta-subvalue { font-size: 7pt; }
}
</style></head><body><main class="receipt">
<header class="header">
  <div class="brand">
    ${businessLogo ? `<img class="logo" src="${escapePrintHtml(businessLogo)}" alt="${escapePrintHtml(businessName)}" onerror="this.style.display='none'">` : ''}
    <div class="business-copy"><div class="business-name-lockup"><div class="business-name-primary">${escapePrintHtml(printBusinessName.primary)}</div>
      ${printBusinessName.secondary ? `<div class="business-name-secondary">${printBusinessName.secondaryUnits.map(unit => `<span>${escapePrintHtml(unit)}</span>`).join('')}</div>` : ''}
      </div>
      <div class="contact-line">
      ${businessAddress ? `<div class="business-detail">${escapePrintHtml(businessAddress)}</div>` : ''}
        ${businessPhone ? `<div class="business-detail">Phone: ${escapePrintHtml(businessPhone)}</div>` : ''}
       
      </div>
    </div>
  </div>
  <div class="receipt-heading"><div class="receipt-title">${translations?.returnReceipt || 'Purchase Return Receipt'}</div></div>
</header>
<section class="meta">
  <span><strong>${translations?.supplier || 'Supplier'}</strong><span class="meta-value">${escapePrintHtml(supplierName)}</span>${supplierPhone ? `<small class="meta-subvalue">${translations?.phone || 'Phone'}: ${escapePrintHtml(supplierPhone)}</small>` : ''}</span>
  <span><strong>${translations?.returnNumber || 'Return No.'}</strong><span class="meta-value">#${escapePrintHtml(returnNumber)}</span></span>
  <span><strong>${translations?.dateTime || 'Date & Time'}</strong><span class="meta-value">${escapePrintHtml(receiptDate)}</span></span>
</section>
${(returnData.original_bill_no || returnData.return_reason) ? `<section class="return-info">
  <div><strong>${translations?.originalBillNumber || 'Original Purchase Invoice'}</strong><span class="meta-value">${escapePrintHtml(returnData.original_bill_no || '—')}</span></div>
  <div><strong>${translations?.returnReason || 'Return Reason'}</strong><span class="meta-value">${escapePrintHtml(returnData.return_reason || '—')}</span></div>
</section>` : ''}
${returnData.items?.length ? `<table><thead><tr>
  <th style="width:5%">#</th><th style="width:43%">${translations?.productName || 'Product'}</th>
  <th style="width:14%">${translations?.quantity || 'Qty'}</th><th style="width:18%">${translations?.price || 'Price'}</th>
  <th style="width:20%">${translations?.total || 'Total'}</th>
</tr></thead><tbody>
${returnData.items.map((item, index) => `<tr><td>${index + 1}</td><td><div class="product">${escapePrintHtml(item.product_name || 'Product')}</div>${item.unit ? `<small class="item-meta">${escapePrintHtml(item.unit)}</small>` : ''}</td><td>${Math.round(Number(item.quantity) || 0)}</td><td>${money(item.price)}</td><td>${money(item.total ?? Number(item.price) * Number(item.quantity))}</td></tr>`).join('')}
</tbody></table>` : ''}
<section class="payment-section"><div class="payment-box">
  <div class="payment-row"><span>${translations?.subtotal || 'Subtotal'}</span><span>${money(returnData.subtotal)}</span></div>
  ${Number(returnData.tax) > 0 ? `<div class="payment-row"><span>${translations?.tax || 'Tax'}</span><span>${money(returnData.tax)}</span></div>` : ''}
  ${Number(returnData.discount) > 0 ? `<div class="payment-row"><span>${translations?.discount || 'Discount'}</span><span>-${money(returnData.discount)}</span></div>` : ''}
  <div class="payment-row total"><span>${translations?.grandTotal || 'Grand Total'}</span><span>${money(returnData.grand_total)}</span></div>
  <div class="payment-row refund"><span>${translations?.refundAmount || 'Supplier Refund Received'}</span><span>${money(returnData.refund_amount)}</span></div>
</div></section>
<footer class="footer"><div class="thanks">${translations?.thankYou || 'Thank you for your business!'}</div><div>Developed by OurZest PVT LTD.</div></footer>
</main><script>
window.onload = async function () {
  await Promise.all(Array.from(document.images).map(img => img.complete ? Promise.resolve() : new Promise(resolve => { img.onload = resolve; img.onerror = resolve; })));
  if (document.fonts && document.fonts.ready) await document.fonts.ready;
  window.onafterprint = function () { window.close(); };
  window.print();
};
</script></body></html>`);
    printWindow.document.close();
    printWindow.focus();
};

// Previous 80 mm thermal printer retained only as an unused reference.
const handlePrintReceiptThermalLegacy = (returnData) => {
    const printWindow = window.open('', '_blank');
    
    if (printWindow) {
        // Get business info with logo and GST
        const shopName = businessInfo?.businessname || 'Shop Name';
        const shopAddress = businessInfo?.businessaddress || '';
        const shopPhone = businessInfo?.phonenumber || '';
        const businessEmail = businessInfo?.email || '';
        const gstNumber = businessInfo?.gst_number || '';
        const businessLogo = businessInfo?.bussinesslogo_url || businessInfo?.bussinesslogo || '';

        const formatCurrency = (amount) => {
            if (!amount && amount !== 0) return 'Rs. 0';
            return `Rs. ${parseFloat(amount).toFixed(0)}`;
        };

        const formatReceiptDateTime = (dateString) => {
            const date = dateString ? new Date(dateString) : new Date();
            const validDate = isNaN(date.getTime()) ? new Date() : date;
            const datePart = validDate.toLocaleDateString('en-IN', {
                day: '2-digit', month: '2-digit', year: 'numeric'
            });
            const timePart = validDate.toLocaleTimeString('en-IN', {
                hour: '2-digit', minute: '2-digit', hour12: true
            });
            return `${datePart} ${timePart}`;
        };

        const escapeHtml = (text) => {
            if (!text) return '';
            return String(text).replace(/[&<>]/g, function(m) {
                if (m === '&') return '&amp;';
                if (m === '<') return '&lt;';
                if (m === '>') return '&gt;';
                return m;
            });
        };

        const receiptDateTime = formatReceiptDateTime(returnData?.date);

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Purchase Return Receipt ${returnData?.return_number || 'N/A'}</title>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <style>
                    @page {
                        size: 80mm auto;
                        margin: 0;
                    }
                    * { 
                        margin: 0; 
                        padding: 0; 
                        box-sizing: border-box; 
                    }
                    body {
                        font-family: 'Courier New', Courier, monospace;
                        background: white;
                        color: #000000;
                        font-size: 12px;
                        line-height: 1.3;
                        padding: 5px 4px;
                        max-width: 80mm;
                        margin: 0 auto;
                        font-weight: 700;
                        /* ✅ BLEED/SCALE FIX: Scale the entire receipt to 90% */
                        transform: scale(0.90);
                        transform-origin: top center;
                        /* ✅ FIX: Center the scaled content properly */
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        min-height: 100vh;
                    }
                    .receipt-wrapper {
                        /* ✅ Wrapper to handle centering */
                        width: 100%;
                        max-width: 80mm;
                        transform-origin: top center;
                    }
                    .receipt-container {
                        max-width: 100%;
                        margin: 0 auto;
                        padding: 0;
                    }
                    .text-center { text-align: center; }
                    .text-right { text-align: right; }
                    .text-left { text-align: left; }
                    .font-bold { font-weight: bold; }
                    .fw-900 { font-weight: 900; }
                    .fw-700 { font-weight: 700; }

                    /* Header - Centered */
                    .header-center {
                        text-align: center;
                        border-bottom: 3px double #000;
                        padding-bottom: 4px;
                        margin-bottom: 4px;
                    }
                    .header-logo {
                        display: block;
                        margin: 0 auto 2px auto;
                        max-height: 85px;
                        max-width: 120px;
                        width: auto;
                        height: auto;
                        object-fit: contain;
                    }
                    .business-name {
                        font-size: 17px;
                        font-weight: 900;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        word-break: break-word;
                        line-height: 1.2;
                    }
                    /* ✅ Phone number - below business name */
                    .business-phone {
                        font-size: 11px;
                        font-weight: 700;
                        margin-top: 1px;
                        color: #000;
                    }
                    .business-address {
                        font-size: 10px;
                        font-weight: 700;
                        margin-top: 1px;
                        word-break: break-word;
                        line-height: 1.4;
                    }
                    .business-contact {
                        font-size: 10px;
                        font-weight: 700;
                        margin-top: 1px;
                    }

                    /* Receipt Title */
                    .receipt-title {
                        text-align: center;
                        font-size: 18px;
                        font-weight: 900;
                        text-transform: uppercase;
                        letter-spacing: 3px;
                        border-bottom: 2px solid #000;
                        padding-bottom: 2px;
                        margin-bottom: 2px;
                    }
                    .receipt-number {
                        text-align: center;
                        font-size: 12px;
                        font-weight: 700;
                        margin-bottom: 3px;
                    }
                    .receipt-number strong {
                        font-weight: 900;
                    }
                    .receipt-supplier {
                        text-align: center;
                        font-size: 12px;
                        font-weight: 700;
                        margin-bottom: 4px;
                    }
                    .receipt-supplier strong {
                        font-weight: 900;
                    }

                    /* Date & Time - Centered */
                    .datetime-center {
                        text-align: center;
                        font-size: 12px;
                        font-weight: 700;
                        padding: 2px 0;
                        margin-bottom: 3px;
                    }

                    /* Supplier Info Box */
                    .supplier-box {
                        background: #f5f5f5;
                        padding: 4px 6px;
                        border-left: 6px solid #000;
                        border: 1px solid #000;
                        border-left-width: 6px;
                        margin: 3px 0 6px 0;
                        font-size: 11px;
                    }

                    /* Reason Box */
                    .reason-box {
                        background: #f5f5f5;
                        padding: 4px 6px;
                        border-left: 6px solid #000;
                        border: 1px solid #000;
                        border-left-width: 6px;
                        margin: 3px 0 6px 0;
                        font-size: 10px;
                        word-break: break-word;
                    }
                    .reason-box strong {
                        font-weight: 900;
                    }

                    /* ===== TABLE WITH FULL BORDERS ===== */
                    .items-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 4px 0 6px 0;
                        border: 2px solid #000;
                    }
                    .items-table th {
                        background: #e0e0e0;
                        text-align: center;
                        padding: 3px 3px;
                        font-size: 9px;
                        text-transform: uppercase;
                        border: 1px solid #000;
                        font-weight: 900;
                    }
                    .items-table td {
                        padding: 3px 3px;
                        border: 1px solid #000;
                        font-size: 10px;
                        font-weight: 700;
                        vertical-align: middle;
                        text-align: center;
                    }
                    .items-table th:first-child, .items-table td:first-child { text-align: center; }
                    .items-table th:nth-child(2), .items-table td:nth-child(2) { text-align: left; }
                    .product-name {
                        font-weight: 900;
                        word-break: break-word;
                    }

                    /* ===== PAYMENT SECTION ===== */
                    .payment-box {
                        margin-top: 4px;
                        padding-top: 3px;
                        border-top: 2px solid #000;
                    }
                    .payment-row {
                        display: flex;
                        justify-content: space-between;
                        padding: 1px 0;
                        font-size: 12px;
                        font-weight: 700;
                    }
                    .payment-row.total {
                        font-size: 14px;
                        font-weight: 900;
                        border-top: 2px solid #000;
                        margin-top: 3px;
                        padding-top: 4px;
                    }
                    .payment-row.refund {
                        font-size: 14px;
                        font-weight: 900;
                        border-top: 2px solid #000;
                        margin-top: 3px;
                        padding-top: 4px;
                    }

                    /* Footer */
                    .footer {
                        text-align: center;
                        font-size: 10px;
                        margin-top: 6px;
                        padding-top: 4px;
                        border-top: 2px solid #000;
                        font-weight: 700;
                    }
                    .footer .thankyou {
                        font-size: 12px;
                        font-weight: 900;
                    }

                    @media print {
                        body { 
                            margin: 0; 
                            padding: 3px;
                            transform: scale(0.90);
                            transform-origin: top center;
                            display: flex;
                            justify-content: center;
                            align-items: flex-start;
                            min-height: 100vh;
                        }
                        .no-print { display: none; }
                    }
                </style>
            </head>
            <body>
                <div class="receipt-wrapper">
                    <div class="receipt-container">
                        
                        <!-- HEADER - Centered -->
                        <div class="header-center">
                            ${businessLogo ? `<img src="${businessLogo}" alt="${escapeHtml(shopName)}" class="header-logo" onerror="this.style.display='none'" />` : ''}
                            <div class="business-name">${escapeHtml(shopName)}</div>
                            <!-- ✅ Phone number - below business name, above address -->
                            ${shopPhone ? `<div class="business-phone">📞 ${escapeHtml(shopPhone)}</div>` : ''}
                            ${shopAddress ? `<div class="business-address">${escapeHtml(shopAddress)}</div>` : ''}
                            <!-- ✅ Email and GST below address (optional) -->
                            ${(businessEmail || gstNumber) ? `
                            <div class="business-contact">
                                ${businessEmail ? `✉ ${escapeHtml(businessEmail)}` : ''}
                                ${businessEmail && gstNumber ? ' | ' : ''}
                                ${gstNumber ? `GST: ${escapeHtml(gstNumber)}` : ''}
                            </div>` : ''}
                        </div>
                        
                        <!-- RECEIPT TITLE -->
                        <div class="receipt-title">${translations?.returnReceipt || 'RETURN RECEIPT'}</div>
                        <div class="receipt-number"><strong>${translations?.returnNumber || 'Return No'}:</strong> ${escapeHtml(returnData?.return_number || '—')}</div>
                        <div class="receipt-supplier">${translations?.supplier || 'Supplier'}: <strong>${escapeHtml(returnData?.supplier_name || 'Walk-in Supplier')}</strong></div>
                        
                        <!-- DATE & TIME - CENTERED -->
                        <div class="datetime-center">
                            <strong>${translations?.date || 'Date'}:</strong> ${receiptDateTime}
                        </div>
                        
                        <!-- ORIGINAL INVOICE -->
                        <div class="datetime-center" style="margin-bottom: 6px;">
                            <strong>${translations?.originalBillNumber || 'Original Purchase Invoice'}:</strong> ${escapeHtml(returnData?.original_bill_no || '—')}
                        </div>
                        
                        <!-- SUPPLIER PHONE (ONLY if available) -->
                        ${returnData?.supplier_phone ? `
                        <div class="supplier-box">
                            <div>📞 ${escapeHtml(returnData.supplier_phone)}</div>
                        </div>
                        ` : ''}
                        
                        <!-- RETURN REASON -->
                        ${returnData?.return_reason ? `
                        <div class="reason-box">
                            <strong>${translations?.returnReason || 'Return Reason'}:</strong> ${escapeHtml(returnData.return_reason)}
                        </div>
                        ` : ''}
                        
                        <!-- PRODUCTS TABLE -->
                        ${returnData?.items && returnData.items.length > 0 ? `
                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th style="width:8%;">#</th>
                                    <th style="width:47%;">${translations?.productName || 'Product'}</th>
                                    <th style="width:15%;">${translations?.quantity || 'Qty'}</th>
                                    <th style="width:15%;">${translations?.price || 'Price'}</th>
                                    <th style="width:15%;">${translations?.total || 'Total'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${returnData.items.map((item, idx) => `
                                <tr>
                                    <td>${idx + 1}</td>
                                    <td class="text-left">
                                        <div class="product-name">${escapeHtml(item.product_name)}</div>
                                        ${item.unit ? `<span style="font-size:8px;color:#555;">${escapeHtml(item.unit)}</span>` : ''}
                                    </td>
                                    <td>${parseFloat(item.quantity).toFixed(0)}</td>
                                    <td>${formatCurrency(item.price)}</td>
                                    <td>${formatCurrency(item.total || item.price * item.quantity)}</td>
                                </tr>
                                `).join('')}
                            </tbody>
                        </table>
                        ` : ''}
                        
                        <!-- PAYMENT SECTION -->
                        <div class="payment-box">
                            <div class="payment-row">
                                <span>${translations?.subtotal || 'Subtotal'}</span>
                                <span>${formatCurrency(returnData?.subtotal || 0)}</span>
                            </div>
                            ${parseFloat(returnData?.tax) > 0 ? `
                            <div class="payment-row">
                                <span>${translations?.tax || 'Tax'}</span>
                                <span>${formatCurrency(returnData?.tax || 0)}</span>
                            </div>` : ''}
                            ${parseFloat(returnData?.discount) > 0 ? `
                            <div class="payment-row">
                                <span>${translations?.discount || 'Discount'}</span>
                                <span>-${formatCurrency(returnData?.discount || 0)}</span>
                            </div>` : ''}
                            <div class="payment-row total">
                                <span>${translations?.grandTotal || 'GRAND TOTAL'}</span>
                                <span>${formatCurrency(returnData?.grand_total || 0)}</span>
                            </div>
                            <div class="payment-row refund">
                                <span>${translations?.refundAmount || 'REFUND AMOUNT'}</span>
                                <span>${formatCurrency(returnData?.refund_amount || 0)}</span>
                            </div>
                        </div>
                        
                        <!-- FOOTER -->
                        <div class="footer">
                            <div class="thankyou">${translations?.thankYou || 'Thank you for your business!'}</div>
                            <div>Developed by OurZest PVT LTD.}</div>
                        </div>
                        
                    </div>
                </div>
                <script>
                window.onload = function() {
                    setTimeout(function() {
                        window.print();
                        window.onafterprint = function() { window.close(); };
                    }, 500);
                };
                </script>
            </body>
            </html>
        `);
        
        printWindow.document.close();
        printWindow.focus();
    }
};

   const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isSubmittingRef.current) {
        showToast('warning', 'Please wait, return is already being processed...');
        return;
    }
    
    isSubmittingRef.current = true;
    if (submitButtonRef.current) {
        submitButtonRef.current.disabled = true;
    }
    
    if (!currentShop?.shop_id) {
        showToast('error', translations?.noShopSelected || 'No shop selected. Please select a shop first.');
        isSubmittingRef.current = false;
        if (submitButtonRef.current) submitButtonRef.current.disabled = false;
        return;
    }
    
    if (!validateForm()) {
        isSubmittingRef.current = false;
        if (submitButtonRef.current) submitButtonRef.current.disabled = false;
        return;
    }

    setSaving(true);

    try {
        const currentUsername = user?.username || '';
        if (!currentUsername) throw new Error("User not authenticated");

        const returnItems = formData.items.filter(item => parseFloat(item.return_quantity) > 0).map(item => ({
            purchase_item_id: item.purchase_item_id || item.id,
            product_id: item.product_id,
            product_name: item.product_name,
            batch_no: item.batch_no,
            barcode: item.barcode,
            unit: item.unit,
            quantity: parseFloat(item.return_quantity),
            price: parseFloat(item.price),
            total: parseFloat(item.price) * parseFloat(item.return_quantity)
        }));

        const payload = {
            action: 'add',
            username: currentUsername,
            shop_id: currentShop.shop_id,
            purchase_id: formData.purchase_id,
            date: formData.date,
            supplier_id: formData.supplier_id,
            supplier_name: formData.supplier_name,
            supplier_phone: formData.supplier_phone,
            subtotal: parseFloat(formData.subtotal),
            tax: parseFloat(formData.tax),
            discount: parseFloat(formData.discount),
            grand_total: parseFloat(formData.grand_total),
            refund_amount: parseFloat(formData.refund_amount),
            payment_method: formData.payment_method,
            payment_account_id: formData.payment_account_id || null,
            return_reason: formData.return_reason,
            notes: formData.notes,
            items: returnItems
        };

        const response = await fetch(RETURN_API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (data.status === 'success') {
            showToast('success', translations?.returnProcessed || 'Return processed successfully!');
            
            const returnForReceipt = {
                ...data.data,
                items: returnItems,
                subtotal: formData.subtotal,
                tax: formData.tax,
                discount: formData.discount,
                grand_total: formData.grand_total,
                refund_amount: formData.refund_amount,
                payment_method: formData.payment_method,
                return_reason: formData.return_reason,
                notes: formData.notes,
                supplier_name: formData.supplier_name,
                supplier_phone: formData.supplier_phone,
                username: currentUsername,
                original_bill_no: originalPurchase?.bill_no,
                date: formData.date
            };
            setCurrentPurchaseReturn(returnForReceipt);

            clearDraftFromStorage();
            refundManuallyEditedRef.current = false;
            
            setFormData({
                ...initialFormData,
                date: new Date().toISOString().split('T')[0],
                return_number: data.data?.return_number || formData.return_number,
                return_number_int: data.data?.return_number_int || formData.return_number_int
            });
            setSearchTerm('');
            setInvoiceFound(false);
            setOriginalPurchase(null);
            setErrors({});
            getNextReturnNumber();
            
            // Open receipt in new window ONLY (no modal)
            setTimeout(() => {
                handlePrintReceipt(returnForReceipt);
            }, 500);
        } else {
            showToast('error', data.message || translations?.failedProcess || 'Failed to process return');
        }
    } catch (error) {
        showToast('error', error.message || translations?.networkError || 'Network error occurred');
    } finally {
        isSubmittingRef.current = false;
        setSaving(false);
        setTimeout(() => { 
            if (submitButtonRef.current) submitButtonRef.current.disabled = false; 
        }, 2000);
    }
};

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
    const hasItemsToReturn = formData.items.some(item => parseFloat(item.return_quantity) > 0);

    return (
        <div className={`ozui-container ${isRTL ? 'ozui-rtl' : 'ozui-ltr'} ${darkMode ? 'ozui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            {/* Receipt Modal */}
            {showReceiptModal && currentPurchaseReturn && (
                <div className="ozui-modal-overlay" onClick={() => setShowReceiptModal(false)}>
                    <div className="ozui-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                        <div className="ozui-modal-header">
                            <h3><FontAwesomeIcon icon={faReceipt} />{translations?.returnReceipt || 'Purchase Return Receipt'}</h3>
                            <button className="ozui-modal-close" onClick={() => setShowReceiptModal(false)}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className="ozui-modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <div className="ozui-receipt-container">
                                <div className="ozui-text-center">
                                    <div className="ozui-shop-name">{businessInfo?.businessname || 'Shop Name'}</div>
                                    {businessInfo?.businessaddress && <div>{businessInfo.businessaddress}</div>}
                                    {businessInfo?.phonenumber && <div>Tel: {businessInfo.phonenumber}</div>}
                                </div>
                                <div className="ozui-divider"></div>
                                <div className="ozui-text-center ozui-font-bold ozui-invoice-title">{translations?.returnReceipt || 'RETURN RECEIPT'}</div>
                                <div className="ozui-bill-info">
                                    <span>{translations?.returnNumber || 'Return #'}: {currentPurchaseReturn?.return_number || 'N/A'}</span>
                                    <span>{translations?.date || 'Date'}: {currentPurchaseReturn?.date}</span>
                                </div>
                                <div className="ozui-bill-info">
                                    <span>{translations?.originalBillNumber || 'Original Purchase Invoice'}: {currentPurchaseReturn?.original_bill_no || 'N/A'}</span>
                                </div>
                                {(currentPurchaseReturn?.supplier_name || currentPurchaseReturn?.supplier_phone) && (
                                    <div className="ozui-supplier-info">
                                        {currentPurchaseReturn?.supplier_name && <div><strong>{currentPurchaseReturn.supplier_name}</strong></div>}
                                        {currentPurchaseReturn?.supplier_phone && <div>{translations?.phone || 'Phone'}: {currentPurchaseReturn.supplier_phone}</div>}
                                    </div>
                                )}
                                <div className="ozui-divider"></div>
                                <table className="ozui-receipt-table">
                                    <thead>
                                        <tr>
                                            <th>{translations?.productName || 'Product'}</th>
                                            <th className="ozui-text-right">{translations?.quantity || 'Qty'}</th>
                                            <th className="ozui-text-right">{translations?.price || 'Price'}</th>
                                            <th className="ozui-text-right">{translations?.total || 'Total'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPurchaseReturn?.items?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.product_name}</td>
                                                <td className="ozui-text-right">{item.quantity}</td>
                                                <td className="ozui-text-right">{Math.round(parseFloat(item.price) || 0)}</td>
                                                <td className="ozui-text-right">{Math.round(parseFloat(item.total || item.price * item.quantity) || 0)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="ozui-divider"></div>
                                <div className="ozui-totals">
                                    <div className="ozui-totals-row"><span>{translations?.subtotal || 'Subtotal'}:</span><span>Rs. {Math.round(parseFloat(currentPurchaseReturn?.subtotal || 0))}</span></div>
                                    {parseFloat(currentPurchaseReturn?.tax) > 0 && <div className="ozui-totals-row"><span>{translations?.tax || 'Tax'}:</span><span>Rs. {Math.round(parseFloat(currentPurchaseReturn?.tax) || 0)}</span></div>}
                                    {parseFloat(currentPurchaseReturn?.discount) > 0 && <div className="ozui-totals-row"><span>{translations?.discount || 'Discount'}:</span><span>-Rs. {Math.round(parseFloat(currentPurchaseReturn?.discount) || 0)}</span></div>}
                                    <div className="ozui-totals-row ozui-grand-total-row"><span className="ozui-font-bold">{translations?.grandTotal || 'Grand Total'}:</span><span className="ozui-font-bold">Rs. {Math.round(parseFloat(currentPurchaseReturn?.grand_total || 0))}</span></div>
                                    <div className="ozui-totals-row ozui-refund-row"><span className="ozui-font-bold">{translations?.refundAmount || 'Supplier Refund Received'}:</span><span className="ozui-font-bold" style={{ color: '#059669' }}>Rs. {Math.round(parseFloat(currentPurchaseReturn?.refund_amount || 0))}</span></div>
                                </div>
                                <div className="ozui-divider"></div>
                                <div className="ozui-text-center">{translations?.refundMethod || 'Refund Method'}: {(currentPurchaseReturn?.payment_method || 'CASH').toUpperCase()}</div>
                                {currentPurchaseReturn?.return_reason && <div className="ozui-text-center">{translations?.returnReason || 'Reason'}: {currentPurchaseReturn.return_reason}</div>}
                                {currentPurchaseReturn?.notes && <div className="ozui-text-center">{currentPurchaseReturn.notes}</div>}
                                <div className="ozui-footer">
                                    <div>{translations?.thankYou || 'Thank you for your business!'}</div>
                                    <div>{translations?.poweredBy || 'Powered by OurZest'}</div>
                                </div>
                            </div>
                        </div>
                        <div className="ozui-modal-footer">
                            <button className="ozui-btn ozui-btn-secondary" onClick={() => setShowReceiptModal(false)}><FontAwesomeIcon icon={faTimes} />{translations?.close || 'Close'}</button>
                            <button className="ozui-btn ozui-btn-primary" onClick={() => window.print()}><FontAwesomeIcon icon={faPrint} />{translations?.print || 'Print'}</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modern Animated Sticky Header */}
            <div className="ozui-sticky-header">
                <div className="ozui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozui-header-content">
                    <div className="ozui-header-left">
                        <div className="ozui-header-title">
                            <h1>{translations?.processReturn || 'Process Purchase Return'}</h1>
                            <p>{translations?.returnItems || 'Search invoice and return items'}</p>
                        </div>
                    </div>
                    
                    <div className="ozui-header-right">
                        <div className="ozui-header-actions">
                            <button 
                                className="ozui-action-btn clear-draft" 
                                onClick={clearDraft}
                                disabled={saving}
                                title={translations?.clearForm || 'Clear Form'}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                                <span>{translations?.clear || 'Clear'}</span>
                            </button>
                            
                            <button 
                                className="ozui-action-btn save-draft" 
                                onClick={saveDraft}
                                disabled={saving}
                                title={translations?.saveDraft || 'Save as Draft'}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                                <span>{translations?.saveDraft || 'Save Draft'}</span>
                            </button>
                            
                            <div className="ozui-drafts-dropdown-container" ref={draftsDropdownRef}>
                                <button 
                                    className="ozui-action-btn drafts-btn" 
                                    onClick={() => setShowDraftsList(!showDraftsList)}
                                    title={translations?.viewDrafts || 'View Drafts'}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    <span>{translations?.drafts || 'Drafts'}</span>
                                    {savedDrafts.length > 0 && <span className="drafts-badge">{savedDrafts.length}</span>}
                                </button>
                                
                                {showDraftsList && (
                                    <div className="ozui-drafts-dropdown">
                                        <div className="drafts-header">
                                            <h4>{translations?.savedDrafts || 'Saved Drafts'}</h4>
                                            <button onClick={() => setShowDraftsList(false)}>×</button>
                                        </div>
                                        <div className="drafts-list">
                                            {savedDrafts.length === 0 ? (
                                                <div className="no-drafts">{translations?.noDraftsSaved || 'No drafts saved'}</div>
                                            ) : (
                                                savedDrafts.map(draft => (
                                                    <div key={draft.id} className="draft-item">
                                                        <div className="draft-info" onClick={() => loadDraft(draft)}>
                                                            <div className="draft-name">
                                                                {draft.return_number || `Return #${draft.id}`}
                                                            </div>
                                                            <div className="draft-details">
                                                                {draft.supplier_name && <span>{draft.supplier_name}</span>}
                                                                {draft.items && <span>{draft.items.length} items</span>}
                                                            </div>
                                                            <div className="draft-date">
                                                                {new Date(draft.savedAt).toLocaleDateString()}
                                                            </div>
                                                        </div>
                                                        <button 
                                                            className="delete-draft-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                deleteDraft(draft.id);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </button>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          

            <form onSubmit={handleSubmit} className="ozui-form">
                {/* Search Invoice Section - Auto-focus on this field */}
                <div className="ozui-form-row">
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                ref={invoiceSearchRef}
                                type="text"
                                id="invoice_search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && searchInvoice()}
                                placeholder=" "
                                disabled={saving}
                                autoComplete="off"
                            />
                            <label htmlFor="invoice_search">
                                <FontAwesomeIcon icon={faSearch} />
                                {translations?.searchPlaceholder || 'Enter Purchase Bill Number, Supplier Name or Phone'}
                            </label>
                            <button 
                                type="button" 
                                className="ozui-search-btn" 
                                onClick={searchInvoice} 
                                disabled={searching || saving}
                                style={{ position: 'absolute', right: '0.7rem', top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', color: 'var(--ozui-primary)', cursor: 'pointer' }}
                            >
                                {searching ? <FontAwesomeIcon icon={faSpinner} spin /> : <FontAwesomeIcon icon={faSearch} />}
                            </button>
                        </div>
                        {errors.invoice && <small>{errors.invoice}</small>}
                    </div>
                </div>

                {invoiceFound && originalPurchase && (
                    <>
                        {/* Return Information */}
                        <div className="ozui-form-row">
                            <div className="ozui-field">
                                <div className="ozui-input-wrapper">
                                    <input
                                        type="text"
                                        id="return_number"
                                        value={formData.return_number}
                                        readOnly
                                        placeholder=" "
                                        className="ozui-readonly-input"
                                    />
                                    <label htmlFor="return_number">
                                        <FontAwesomeIcon icon={faFileInvoice} />
                                        {translations?.returnNumber || 'Return Number'}
                                    </label>
                                </div>
                            </div>

                            <div className="ozui-field">
                                <div className="ozui-input-wrapper">
                                    <input
                                        type="date"
                                        name="date"
                                        id="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                        placeholder=" "
                                        disabled={saving}
                                    />
                                    <label htmlFor="date">
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                        {translations?.returnDate || 'Return Date'}
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Original Purchase Invoice */}
                        <div className="ozui-form-row">
                            <div className="ozui-field">
                                <div className="ozui-input-wrapper">
                                    <input
                                        type="text"
                                        value={originalPurchase.bill_no}
                                        readOnly
                                        placeholder=" "
                                        className="ozui-readonly-input"
                                    />
                                    <label htmlFor="original_bill">
                                        <FontAwesomeIcon icon={faFileInvoice} />
                                        {translations?.originalBillNumber || 'Original Purchase Bill Number'}
                                    </label>
                                </div>
                            </div>

                            <div className="ozui-field">
                                <div className="ozui-input-wrapper">
                                    <input
                                        type="text"
                                        value={originalPurchase.date}
                                        readOnly
                                        placeholder=" "
                                        className="ozui-readonly-input"
                                    />
                                    <label htmlFor="original_date">
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                        {translations?.originalDate || 'Original Date'}
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Supplier Details */}
                        <div className="ozui-form-row">
                            <div className="ozui-field">
                                <div className="ozui-input-wrapper">
                                    <input
                                        type="text"
                                        value={formData.supplier_name}
                                        readOnly
                                        placeholder=" "
                                        className="ozui-readonly-input"
                                    />
                                    <label htmlFor="supplier_name">
                                        <FontAwesomeIcon icon={faUser} />
                                        {translations?.supplierName || 'Supplier Name'}
                                    </label>
                                </div>
                            </div>

                            <div className="ozui-field">
                                <div className="ozui-input-wrapper">
                                    <input
                                        type="text"
                                        value={formData.supplier_phone}
                                        readOnly
                                        placeholder=" "
                                        className="ozui-readonly-input"
                                    />
                                    <label htmlFor="supplier_phone">
                                        <FontAwesomeIcon icon={faPhone} />
                                        {translations?.supplierPhone || 'Phone Number'}
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Items Table */}
                        {formData.items.length > 0 && (
                            <PurchaseReturnItemsTable 
                                items={formData.items} 
                                onQuantityChange={handleQuantityChange} 
                                onRemove={removeItem} 
                                errors={errors} 
                                disabled={saving} 
                                translations={translations} 
                                isRTL={isRTL} 
                            />
                        )}
                        {errors.items && <div className="ozui-error-message"><small>{errors.items}</small></div>}

                        {/* Calculations Section */}
                        {hasItemsToReturn && (
                            <>
                                <div className="ozui-form-section">
                                    <div className="ozui-calculations">
                                        <div className="ozui-calculation-row">
                                            <span className="ozui-calculation-label">{translations?.subtotal || 'Subtotal'}:</span>
                                            <span className="ozui-calculation-value">Rs. {formData.subtotal}</span>
                                        </div>
                                        <div className="ozui-calculation-row">
                                            <span className="ozui-calculation-label">{translations?.tax || 'Tax'}:</span>
                                            <div className="ozui-input-wrapper ozui-small-input">
                                                <input type="number" name="tax" value={formData.tax} onChange={handleChange} step="1" min="0" placeholder="0" disabled={saving} />
                                            </div>
                                        </div>
                                        <div className="ozui-calculation-row">
                                            <span className="ozui-calculation-label">{translations?.discount || 'Discount'}:</span>
                                            <div className="ozui-input-wrapper ozui-small-input">
                                                <input type="number" name="discount" value={formData.discount} onChange={handleChange} step="1" min="0" placeholder="0" disabled={saving} />
                                            </div>
                                        </div>
                                        <div className="ozui-calculation-row ozui-grand-total">
                                            <span className="ozui-calculation-label">{translations?.grandTotal || 'Grand Total'}:</span>
                                            <span className="ozui-calculation-value">Rs. {formData.grand_total}</span>
                                        </div>
                                        <div className="ozui-calculation-row">
                                            <span className="ozui-calculation-label">{translations?.refundMethod || 'Refund Method'}:</span>
                                            <div className="ozui-input-wrapper ozui-small-input">
                                                <select name="payment_method" value={formData.payment_method} onChange={(event) => {
                                                    const value = event.target.value;
                                                    setFormData(previous => ({ ...previous, payment_method: value, payment_account_id: '' }));
                                                }} disabled={saving}>
                                                    <option value="cash">{translations?.cash || 'Cash'}</option>
                                                    <option value="digital_wallet">{translations?.wallet || 'Digital Wallet'}</option>
                                                    <option value="bank_account">{translations?.bankTransfer || 'Bank Account'}</option>
                                                </select>
                                            </div>
                                        </div>
                                        {formData.payment_method !== 'cash' && (
                                            <div className="ozui-calculation-row">
                                                <span className="ozui-calculation-label">{translations?.account || 'Receiving Account'}:</span>
                                                <div className="ozui-input-wrapper ozui-small-input">
                                                    <select name="payment_account_id" value={formData.payment_account_id} onChange={handleChange} disabled={saving} required>
                                                        <option value="">{translations?.selectAccount || 'Select account'}</option>
                                                        {paymentAccounts
                                                            .filter(account => account.account_type === formData.payment_method && Number(account.is_active ?? 1) === 1)
                                                            .map(account => (
                                                                <option key={account.account_id} value={account.account_id}>
                                                                    {[account.provider_name, account.account_title, account.account_number].filter(Boolean).join(' — ')}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                        <div className="ozui-calculation-row ozui-refund-amount">
                                            <span className="ozui-calculation-label">{translations?.refundAmount || 'Supplier Refund Received'}:</span>
                                            <div className="ozui-input-wrapper ozui-small-input">
                                                <input
                                                    type="number"
                                                    name="refund_amount"
                                                    value={formData.refund_amount}
                                                    onChange={(event) => {
                                                        refundManuallyEditedRef.current = true;
                                                        const value = Math.min(
                                                            Math.max(0, Number(event.target.value) || 0),
                                                            Number(formData.grand_total) || 0
                                                        );
                                                        setFormData(previous => ({ ...previous, refund_amount: String(value) }));
                                                    }}
                                                    min="0"
                                                    max={formData.grand_total}
                                                    step="0.01"
                                                    disabled={saving}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ozui-form-actions">
                                    <button 
                                        ref={submitButtonRef}
                                        type="submit" 
                                        className="ozui-btn ozui-btn-primary" 
                                        disabled={saving}
                                        style={{ background: 'linear-gradient(135deg, #dc2626, #991b1b)' }}
                                    >
                                        {saving ? (
                                            <>
                                                <FontAwesomeIcon icon={faSpinner} spin />
                                                <span>{translations?.saving || 'Processing...'}</span>
                                            </>
                                        ) : (
                                            <>
                                                <FontAwesomeIcon icon={faUndo} />
                                                <span>{translations?.processReturnBtn || 'Process Purchase Return'}</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </>
                        )}
                    </>
                )}
            </form>

            {loading && (
                <div className="ozui-loading-overlay">
                    <div className="ozui-loading-content">
                        <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                        <p>{translations?.loading || 'Loading...'}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CosmeticsPurchaseReturn;

